<template>
  <div class="rrd-recognition-list">
    <div
      v-for="item in normalized"
      :key="item.countryCode"
      class="rrd-recognition-row"
      :class="statusClass(item.status)"
    >
      <span class="rrd-country">{{ item.countryCode }}</span>

      <span class="rrd-icon">
        {{ statusIcon(item.status) }}
      </span>

      <span class="rrd-text">
        <template v-if="item.status === 'FULL' && item.recognizedAt">
          {{ item.recognizedAt }}
        </template>
        <template v-else>
          {{ statusText(item.status) }}
        </template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecognitionList",
  props: {
    results: { type: Array, default: () => [] },
  },
  computed: {
    normalized() {
      return (this.results || [])
        .map(r => ({
          countryCode: (r.countryCode || r.country).toUpperCase(),
          status: (r.status || "UNKNOWN").toUpperCase(),
          recognizedAt: r.recognized_at || r.cycle || null,
        }))
        .filter(r => r.countryCode);
    },
  },
  methods: {
    statusIcon(s) {
      if (s === "FULL") return "✓";
      if (s === "NOT") return "✕";
      return "•";
    },
    statusText(s) {
      if (s === "NOT") return "Not recognized";
      return "—";
    },
    statusClass(s) {
      return `is-${s.toLowerCase()}`;
    },
  },
};
</script>

<style scoped>
.rrd-recognition-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
}

.rrd-recognition-row {
  display: grid;
  grid-template-columns: 32px 16px auto;
  align-items: center;
  gap: 6px;
}

.rrd-country {
  font-weight: 600;
}

.is-full .rrd-icon { color: #198754; }
.is-not .rrd-icon { color: #dc3545; }

.rrd-text {
  color: #444;
}
</style>
